import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

let apiURL = '';

if(process.env.NODE_ENV == 'development') {
  apiURL = 'https://brannvernskolen-website.ddev.site';
} 

const store = new Vuex.Store({
  state: {
    error: null,
    loading: false,
    postingData: false,
    resultRegistered: false,
    schools: null,
    schoolsresult: [],
    resultSchools: [],
    results: [],
    years: null,
    year: null,
    questions: [
      {
        text: 'Fant ingen ladere med synlig skade eller slitasje',
        notOk: {
          percent: '0%',
          style: {backgroundColor: '#ca9e3b', width: '100px'}
        },
        ok: {
          percent: '0%',
          style: {backgroundColor: '#fdc648', width: '50px'}
        }
      },
      {
        text: 'Minst én røykvarsler hjemme virker med testknappen.',
        notOk: {
          percent: '0%',
          style: {backgroundColor: '#bf6801', width: '70px'}
        },
        ok: {
          percent: '0%',
          style: {backgroundColor: '#f08000', width: '80px'}
        }
      },
      {
        text: 'Familien har avtalt en fast møteplass utenfor huset i tilfelle brann.',
        notOk: {
          percent: '0%',
          style: {backgroundColor: '#ac121e', width: '90px'}
        },
        ok: {
          percent: '0%',
          style: {backgroundColor: '#d61726', width: '60px'}
        }
      },
      {
        text: 'De voksne i huset kan 20/20-regelen for førstehjelp ved brannskade.',
        notOk: {
          percent: '0%',
          style: {backgroundColor: '#06835b', width: '30px'}
        },
        ok: {
          percent: '0%',
          style: {backgroundColor: '#08a572', width: '50px'}
        }
      }
    ]
  },
  mutations: {
    setError (state, value) {
      state.error = value
    },
    setLoading (state, value) {
      state.loading = value
    },
    setPostingData (state, value) {
      state.postingData = value
    },
    setResultRegistered (state, value) {
      state.resultRegistered = value
    },
    setSchools (state, value) {
      state.schools = value
    },
    setSchoolsResult (state, payload) {
      state.schoolsresult[payload.year] = payload.value
    },
    setResultSchools (state, value) {
      state.resultSchools = value
    },
    setYears (state, value) {
      state.years = value
    },
    setYear (state, value) {
      state.year = value
    },
    setGraph (state) {
      var fetchedResult = []
      if (state.results[state.year]) {
        fetchedResult = state.results[state.year][state.schoolid]
      }

      if (state.klass && state.klass !== 'alle' && fetchedResult) {
        fetchedResult = fetchedResult.filter(function (item) {
          return item.SchoolLevel === state.klass
        })
      }

      if (fetchedResult) {
        // Summarize
        let q1Yes = 0
        let q1No = 0
        let q2Yes = 0
        let q2No = 0
        let q3Yes = 0
        let q3No = 0
        let q4Yes = 0
        let q4No = 0
        for (let i = 0; i < fetchedResult.length; i++) {
          q1Yes += fetchedResult[i].Q1_yes
          q1No += fetchedResult[i].Q1_no
          q2Yes += fetchedResult[i].Q2_yes
          q2No += fetchedResult[i].Q2_no
          q3Yes += fetchedResult[i].Q3_yes
          q3No += fetchedResult[i].Q3_no
          q4Yes += fetchedResult[i].Q4_yes
          q4No += fetchedResult[i].Q4_no
        }

        //
        let result = [
          {yes: parseInt(q1Yes), no: parseInt(q1No)},
          {yes: parseInt(q2Yes), no: parseInt(q2No)},
          {yes: parseInt(q3Yes), no: parseInt(q3No)},
          {yes: parseInt(q4Yes), no: parseInt(q4No)}
        ]
        //
        for (let i = 0; i < result.length; i++) {
          let total = parseInt(result[i].yes) + parseInt(result[i].no)
          let yes = parseInt(result[i].yes)
          let no = parseInt(result[i].no)
          // Calculate percentage of "OK answers"
          let ok = state.questions[i].ok
          let okPercent = '0%'
          if (total !== 0 && yes !== 0) {
            okPercent = parseInt((yes / total) * 100) + '%'
          }
          ok.percent = okPercent
          ok.style.width = okPercent
          state.questions[i].ok = ok

          // Calculate percentage of "Not OK answers"
          let notOk = state.questions[i].notOk
          let notOkPercent = '0%'
          if (total !== 0 && no !== 0) {
            notOkPercent = parseInt((parseInt(result[i].no) / total) * 100) + '%'
          }
          notOk.percent = notOkPercent
          notOk.style.width = notOkPercent
          state.questions[i].notOk = notOk
        }
      }
    },

    setResults (state, value) {
      if (!state.results[state.year]) { state.results[state.year] = [] }
      state.results[state.year][state.schoolid] = value
    },
    setSchoolID (state, value) {
      state.schoolid = value
    }
  },
  actions: {
    loadSchools ({commit}) {
      store.commit('setLoading', true)
      axios
        .get(apiURL + '/api/getSchools')
        .then(response => {
          store.commit('setSchools', response.data.data)
          store.commit('setLoading', false)
        })
        .catch(error => {
          store.commit('setError', error)
          store.commit('setLoading', false)
        })
    },
    registerSchool ({commit}, data) {
      store.commit('setLoading', true)
      store.commit('setPostingData', true)

      const config = {
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': window.csrfToken
        }
      }

      const date = new Date();
      const currentYear = date.getFullYear();
      
      const matchYearTag = window.yearTags.find(tag => {
        return tag.title === currentYear.toString();
      });

      const yearTagId = matchYearTag.id;
      
      axios
        .post(apiURL + '/actions/guest-entries/save', {
          sectionUid: 'de5ccd7d-c321-456e-9edc-24f815865cd6',
          title: data.email,
          "fields": {
            "email": data.email,
            "relatedSchool": [
              data.school
            ],
            "schoolLevel": data.level,
            "year": [
              yearTagId
            ],
            "total": data.total,
            "q1Yes": data.q1_yes,
            "q1No": data.q1_no,
            "q2Yes": data.q2_yes,
            "q2No": data.q2_no,
            "q3Yes": data.q3_yes,
            "q3No": data.q3_no,
            "q4Yes": data.q4_yes,
            "q4No": data.q4_no
          }
          // Email: data.email,
          // School: data.school,
          // SchoolLevel: data.level,
          // Total: data.total,
          // Q1_yes: data.q1_yes,
          // Q1_no: data.q1_no,
          // Q2_yes: data.q2_yes,
          // Q2_no: data.q2_no,
          // Q3_yes: data.q3_yes,
          // Q3_no: data.q3_no,
          // Q4_yes: data.q4_yes,
          // Q4_no: data.q4_no
        }, config)
        .then(function (response) {
          store.commit('setLoading', false)
          store.commit('setPostingData', false)
          store.commit('setResultRegistered', true)

          window.location = '/6-klasse/resultater'
        })
        .catch(function (error) {
          store.commit('setError', error)
          store.commit('setLoading', false)
          store.commit('setPostingData', false)
          store.commit('setResultRegistered', false)
        })
    },
    loadSchoolsResult ({commit}, year) {
      store.commit('setLoading', true)

      var str = apiURL + '/api/getSchoolsWithResults'

      if (year != null) { str = apiURL + '/api/getSchoolsWithResults?year=' + year }
      axios
        .get(str)
        .then(response => {
          store.commit('setYears', response.data.meta.years)
          if (year === null) {
            store.commit('setYear', response.data.meta.parameters['chosen year'])
          }
          store.commit('setSchoolID', 'total')
          store.commit('setResults', response.data.meta.total)
          store.commit('setGraph', response.data.meta.total)
          store.commit('setSchoolsResult', {year: response.data.meta.parameters['chosen year'], value: response.data.data})
          store.commit('setResultSchools', response.data.data)
          store.commit('setLoading', false)
        })
        .catch(error => {
          store.commit('setError', error)
          store.commit('setLoading', false)
        })
    },
    loadResults ({commit}, payload) {
      store.commit('setLoading', true)
      var str = apiURL + '/api/getSchoolResultsByID?id=' + payload.id + '&year=' + payload.year
      axios
        .get(str)
        .then(response => {
          store.commit('setResults', response.data.data, payload.id, response.data.meta.parameters['chosen year'])
          store.commit('setGraph', response.data.meta.total)
          store.commit('setLoading', false)
        })
        .catch(error => {
          store.commit('setError', error)
          store.commit('setLoading', false)
        })
    },
    getResults ({commit}, state) {
      if (state.year && (!state.results[state.year] || !state.results[state.year][state.schoolid])) {
        if (!state.results[state.year]) {
          state.results[state.year] = []
        }
        store.dispatch('loadResults', {id: state.schoolid, year: state.year})
        store.commit('setGraph')
        return []
      } else {
        store.commit('setGraph')
        return state.results[state.year][state.schoolid]
      }
    },
    checkSchoolsResult ({commit}, state) {
      if (state.year && !state.schoolsresult[state.year]) {
        store.dispatch('loadSchoolsResult', state.year)
      } else {
        store.commit('setResultSchools', state.schoolsresult[state.year])
      }
    }
  },
  getters: {
    isLoading (state) {
      return state.loading
    },
    isPostingData (state) {
      return state.postingData
    },
    isResultRegistered (state) {
      return state.resultRegistered
    },
    getYears (state) {
      if (!state.years) { return [] } else { return state.years }
    },
    getSchools (state) {
      return state.schools
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js